/**
 * Set the max height of the table body based on the window height and the page header, table filters, and table pagination heights.
 * @returns {void}
 */
function setTableBodyMaxHeight() {
    const pageHeader = document.getElementById('page-header');
    const tableFilters = document.getElementById('table-filters');
    const tablePagination = document.getElementById('table-pagination');
    const table = document.getElementById('table-body');

    if (pageHeader && tableFilters && tablePagination && table) {
        table.style.maxHeight = `calc(${window.innerHeight}px - ${pageHeader.clientHeight + tableFilters.clientHeight + tablePagination.clientHeight}px)`;
    }
}
export default setTableBodyMaxHeight;